import type { FC} from 'react';
import { useMemo, type JSX } from 'react';
import type { ICustomIconPropertiesModel } from './models/custom-icon-properties.model';

const BidtheatreIcon: FC<ICustomIconPropertiesModel> = ({ fontSize, color }): JSX.Element => {
  const size = useMemo(() => {
    switch (fontSize) {
      case 'large':
        return 32;
      case 'medium':
        return 24;
      case 'small':
        return 22;
      default:
        return 32;
    }
  }, []);
  return <img src="/images/bidtheatre/bidtheatre.png" width={size} height={size} />;
};

export default BidtheatreIcon;
